import { render, staticRenderFns } from "./userBoardDetails.vue?vue&type=template&id=121aa8b8&scoped=true"
import script from "./userBoardDetails.vue?vue&type=script&lang=js"
export * from "./userBoardDetails.vue?vue&type=script&lang=js"
import style0 from "./userBoardDetails.vue?vue&type=style&index=0&id=121aa8b8&prod&lang=scss&scoped=true"
import style1 from "./userBoardDetails.vue?vue&type=style&index=1&id=121aa8b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121aa8b8",
  null
  
)

export default component.exports